import { Button, Col, Row } from "antd";
import { useEffect } from "react";
import { setHeaderName } from "../../../services/SetHeaderName";
import './style/Ingredients.scss'
import { IngredientsList } from "./components/IngredientsList";

export const Ingredients = () => {

    useEffect(() => {
        setHeaderName("Ingredients")
    }, []);
    return (
        <div className="Ingredients">
                <Row className="mb-2">
                    <Col span={24}>
                        <IngredientsList />
                    </Col>
                </Row>
        </div>
    )
}
